export default [{ path: 'questionnaire', component: () => import('pages/questionnaire/index') }];
